export const WHITE = 'WHITE';
export const BLACK = 'BLACK';
